import React, { useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { FaFile } from "react-icons/fa6";
import { DataState } from "../context/DataProvider";
import toast from "react-hot-toast";
import { updateTaskDataSources } from "../services/api"; // Import fetch-based API service
import { FaCheckCircle } from "react-icons/fa";
import Loader2 from "./custom/Loader2";

const SelectDataSource = ({ closeModal }) => {
  const {
    userGoogleId,
    allUserDataSourceFiles: files,
    setAllUserDataSourceFiles: setFiles,
    currentTaskDataSourceFiles: currentDataSources,
    setCurrentTaskDataSourceFiles: setCurrentDataSources,
    currentTaskId: taskId,
    fetchDataSourceFiles: fetchFiles,
  } = DataState(); // Assuming you'll define currentDataSources in context
  // Pre-select the currently selected files based on the full file objects
  const [selectedDataSources, setSelectedDataSources] = useState([
    ...currentDataSources,
  ]);
  const [isloading, setIsloading] = useState(false);
  const [error, setError] = useState(null);

  const handleSelect = (file) => {
    setSelectedDataSources(
      (prevSelected) =>
        prevSelected.find((selected_file_id) => selected_file_id === file.file_id)
          ? prevSelected.filter((selected_file_id) => selected_file_id !== file.file_id) // Remove if already selected
          : [...prevSelected, file.file_id] // Add if not selected
    );
  };

  const handleConfirm = async () => {
    try {
        // Create a Set of valid file_ids from allUserDataSourceFiles
    const validFileIds = new Set(files.map((file) => file.file_id));

    // Filter selectedDataSources to include only valid and unique entries
    const seen = new Set();
    const validSelectedDataSources = selectedDataSources.filter((file_id) => {
      const isValid = validFileIds.has(file_id);
      const isUnique = !seen.has(file_id);
      if (isValid && isUnique) {
        seen.add(file_id);
        return true;
      }
      return false;
    });
      // Extract file IDs to send to the API
      const selectedFileIds = validSelectedDataSources
      setIsloading(true);
      // Call API to update task data sources using fetch
      if (!taskId) {
        setCurrentDataSources(validSelectedDataSources);
        toast.success("Selected data sources updated");
        return;
      }
      const result = await updateTaskDataSources(
        taskId,
        userGoogleId,
        selectedFileIds
      );

      if (result.error) {
        setIsloading(false);
        throw new Error(result.error);
      }

      setCurrentDataSources(validSelectedDataSources); // Update the full file info in context
      toast.success("Selected data sources updated");
      setIsloading(false);
    } catch (err) {
      setError("Failed to update data sources");
      setIsloading(false);
      toast.error(err.message);
    } finally {
      setIsloading(false);
      closeModal(); // Close the modal
    }
  };

  return (
    <div className="flex w-full">
      <div className="text-white rounded-lg shadow-lg relative w-full">
        {files.length > 0 ? (
          <>
            <div className="space-y-3">
              <ul className="space-y-2">
                {files.map((file) => {
                  if (file.status != "success" && !file.accessible) {
                    return null;
                  }
                  const isSelected = selectedDataSources.some(
                    (selected_file_id) => selected_file_id === file.file_id
                  );
                  return (
                    <li
                      key={file.file_id}
                      onClick={() => handleSelect(file)}
                      className={`flex justify-between items-center rounded-md w-full p-3 cursor-pointer ${isSelected
                        ? "bg-white text-black"
                        : "bg-zinc-800 text-white"
                        }`}
                    >
                      <div className="flex items-center gap-2 max-w-[70%]">
                        <span>
                          <FaFile className="text-[#5566FF] text-lg" />
                        </span>
                        <span
                          className={`text-sm truncate ${isSelected ? "text-black" : "text-white"
                            }`}
                          title={`${file.original_filename}\nUploaded at: ${file.timestamp}`}
                        >
                          {file.original_filename}
                        </span>
                      </div>

                      {isSelected ? (
                        <FaCheckCircle className="text-green-500 w-3 h-full" />
                      ) : (
                        <div className="border hover:border-cyan-500 rounded-full w-3 h-3"></div>
                      )}
                    </li>
                  );
                })}
              </ul>

            </div>
            <div className="flex justify-end">
              <button
                onClick={handleConfirm}
                disabled={isloading}
                className="bg-zinc-200 text-zinc-800 px-3 py-1 rounded-lg mt-4 flex items-center gap-1"
              >
                {/* Confirm */}
                {isloading && <Loader2 />}
                {isloading ? "Confirming" : "Confirm"}
              </button>
            </div>
          </>
        ) : (

          <div className="bg-black w-full h-40 flex items-center rounded-md justify-center text-zinc-400">
            No DataSource
          </div>
        )}
        {error && <div className="text-red-500 mb-4">{error}</div>}
      </div>
    </div>
  );
};

export default SelectDataSource;